/* eslint-disable max-lines */
/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory } from "Utils/sagaUtils";
import noop from "lodash.noop";
import { chainInstanceActionResult, loadChainInstance, upsertChainInstance, defaultChainInstance } from "./chainInstance.api";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import { v4 as uuidv4 } from "uuid";
import {
    CHAIN_INSTANCE_LOAD_REQUESTED,
    CHAIN_INSTANCE_SAVE_REQUESTED,
    // CHAIN_INSTANCE_SAVE_REQUESTED,
    loadFail,
    loadSuccess,
    saveFail,
    saveSuccess,
} from "./chainInstance.duck";
export const withBoundActions = injectBoundActionCreatorsFactory(
    {
        saveSuccess,
        saveFail,
        loadSuccess,
        loadFail,
    },
    () => "AI.chainInstance"
);

export const withApiContext = injectApiWithContextFactory(
    {
        chainInstanceActionResult,
        loadChainInstance,
        upsertChainInstance,
    },
    injectBoundGQLClient
);

function* loadChainInstanceSaga({
    api: { loadChainInstance = noop, upsertChainInstance = noop },
    actions: { loadSuccess, loadFail },
    resolve = noop,
    reject = noop,
}) {
    try {
        let result = yield loadChainInstance();
        if (result === null || !result) {
            const { chain, systemChain } = defaultChainInstance();
            result = yield upsertChainInstance({ chain: chain(), systemChain: systemChain() });
        }
        yield loadSuccess(result);
        yield call(resolve);
    } catch (error) {
        yield loadFail(error);
        yield call(reject, error);
    }
}

function* upsertChainInstanceSaga({
    data: { chain, systemChain },
    api: { upsertChainInstance = noop, chainInstanceActionResult = noop },
    actions: { saveSuccess, saveFail },
    resolve = noop,
    reject = noop,
    mdContext = {},
}) {
    try {
        const ensureIdInChain = chain.map(obj => {
            return obj.hasOwnProperty("id") ? obj : { ...obj, id: uuidv4() };
        });

        const ensureIdInSystemChain = systemChain.map(obj => {
            return obj.hasOwnProperty("id") ? obj : { ...obj, id: uuidv4() };
        });

        const result = yield upsertChainInstance({ chain: ensureIdInChain, systemChain: ensureIdInSystemChain });
        yield saveSuccess(result);
        yield chainInstanceActionResult({ actionResult: { event: "chainInstancesModified", projectId: mdContext.project, success: true } });
        yield call(resolve);
    } catch (error) {
        yield saveFail(error);
        yield chainInstanceActionResult({ actionResult: { success: false, message: error } });
        yield call(reject, error);
    }
}

export default () =>
    function* rootSaga() {
        yield takeEvery(CHAIN_INSTANCE_LOAD_REQUESTED, withApiContext(withBoundActions(loadChainInstanceSaga)));
        yield takeEvery(CHAIN_INSTANCE_SAVE_REQUESTED, withApiContext(withBoundActions(upsertChainInstanceSaga)));
    };
